/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pagination-wrapper[_ngcontent-%COMP%]{text-align:center!important;color:#ff6000;display:inline-block;-ms-grid-row:2;grid-row:2}#selected-page[_ngcontent-%COMP%]{margin-bottom:0;font-size:.9rem}.fa[_ngcontent-%COMP%]{font-size:.7rem;margin:0 .6rem;cursor:pointer}.fa.disabled[_ngcontent-%COMP%]{cursor:auto;color:#e8b987}"];
export { styles as styles };
//# sourceMappingURL=pagination.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/pagination/pagination.component.scss.shim.ngstyle.js
// module id = 1687
// module chunks = 27 28 29